import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Building, Palette, Phone, FileText, Link2 } from 'lucide-react';
import AdminLocale from './AdminLocale';
import AdminBranding from './AdminBranding';
import AdminContacts from './AdminContacts';
import AdminPreviewLinks from './AdminPreviewLinks';

const TABS = [
  { key: 'info', label: 'Info Locale', icon: Building },
  { key: 'branding', label: 'Brand Identity', icon: Palette },
  { key: 'contacts', label: 'Contatti', icon: Phone },
  { key: 'preview', label: 'Anteprima & link', icon: Link2 },
];
const TAB_KEYS = TABS.map(t => t.key);

export default function AdminBrand() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = TAB_KEYS.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'info';
  const [tab, setTab] = useState(initialTab);

  // Keep URL in sync when tab changes (so the page is bookmarkable / deep-linkable)
  useEffect(() => {
    const current = searchParams.get('tab');
    if (current !== tab) {
      const next = new URLSearchParams(searchParams);
      next.set('tab', tab);
      setSearchParams(next, { replace: true });
    }
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  // React to back/forward (URL → state)
  useEffect(() => {
    const urlTab = searchParams.get('tab');
    if (urlTab && TAB_KEYS.includes(urlTab) && urlTab !== tab) {
      setTab(urlTab);
    }
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="admin-brand-page">
      {/* Tab navigation */}
      <div className="px-6 md:px-8 lg:px-10 pt-6">
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-[#1A1A1A] mb-1">Brand</h1>
        <p className="text-[#64748B] text-sm mb-4">Gestisci le informazioni, l'identita visiva, i contatti e i link del tuo brand</p>
        <div className="flex items-center gap-1 bg-slate-100 rounded-xl p-1 w-fit overflow-x-auto">
          {TABS.map(t => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`brand-tab-${t.key}`}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap ${
                tab === t.key ? 'bg-white text-[#D44E20] shadow-sm' : 'text-slate-500 hover:text-slate-700'
              }`}>
              <t.icon size={15} />
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      {tab === 'info' && <AdminLocale />}
      {tab === 'branding' && <AdminBranding />}
      {tab === 'contacts' && <AdminContacts />}
      {tab === 'preview' && <AdminPreviewLinks />}
    </div>
  );
}
